'use client';

import { Button, CertificationBadge } from '@common/components';
import { SvgInfo } from '@common/icon';
import { cn } from '@core/utils';
import React from 'react';
import { TERM_CATEGORY } from '@/api';
import { CustomLink } from '@/app/_components/CustomLink';
import Instagram from '@/assets/svgs/instagram.svg';
import Logo from '@/assets/svgs/logo.svg';
import NaverBlog from '@/assets/svgs/naver_blog.svg';
import Youtube from '@/assets/svgs/youtube.svg';
import { ROUTES } from '@/constants';
import { useCustomRouter } from '@/hooks/useCustomRouter';
import { useDeviceInfoStore } from '@/stores/DeviceStore';
import { useGlobalStore } from '@/stores/GlobalStore';
interface FooterMobileProps {
  className?: string;
}
export const FooterMobile = ({
  className
}: FooterMobileProps) => {
  const appVersion = useDeviceInfoStore(state => state.appVersion);
  const setTermsDrawerType = useGlobalStore(state_0 => state_0.setTermsDrawerType);
  let devCount = 0;
  const router = useCustomRouter();
  return <footer className={cn('bg-Gray-white px-20 py-40 pb-80 font-400 text-Gray-700 typo-body4', className)}>
      <Logo className="h-28 w-86 [&>path]:fill-Gray-400" />
      <div className="flex items-start justify-between py-24">
        <ul className="flex flex-col gap-10 font-600 typo-body4">
          <li>
            <a href="https://forms.gle/gZjgg76YpXcWgw2p9" rel="noreferrer" target="_blank" className="text-Gray-900 no-underline">
              제휴 및 입점 문의
            </a>
          </li>
          <li>
            <CustomLink href={ROUTES.MY_NOTICE} className="text-Gray-900 no-underline">
              공지사항
            </CustomLink>
          </li>
        </ul>
      </div>
      <ul className="mb-20 flex flex-col flex-wrap items-start gap-2 p-0 text-Gray-600">
        {/* eslint-disable-next-line jsx-a11y/no-noninteractive-element-interactions */}
        <li className="whitespace-nowrap break-keep flex-center typo-caption1" onClick={() => {
        devCount++;
        if (devCount === 10) {
          router.push(ROUTES.TEST.pathname);
        }
      }}>
          <button type="button">주식회사 웰로</button>
          <div className="mx-8 h-10 w-2 bg-Gray-500" />
          대표 김유리안나
        </li>
        <li className="pointer-events-none whitespace-nowrap break-keep flex-center typo-caption1">
          <span className="mr-4">사업자등록번호:</span> 705-86-02126
        </li>
        <li className="whitespace-nowrap break-keep flex-center typo-caption1">
          통신판매업신고번호&nbsp;
          <a className="text-Gray-700 underline" href="https://www.ftc.go.kr/bizCommPop.do?wrkr_no=7058602126" target="_blank" rel="noreferrer external">
            제2024-세종아름-0756호
          </a>
        </li>
        <li className="whitespace-nowrap break-keep flex-center typo-caption1">
          <address className="not-italic">
            서울오피스: 서울특별시 영등포구 여의대로 108, 4층
          </address>
        </li>
        <li className="whitespace-nowrap break-keep flex-center typo-caption1">
          <address className="not-italic">
            세종오피스: 세종특별자치시 가름로 232, 세종비지니스센터
          </address>
        </li>
        <li className="whitespace-nowrap break-keep flex-center typo-caption1">
          <a className="text-Gray-700 underline" href="mailto:cs@wello.info">
            cs@wello.info
          </a>
          <div className="mx-8 h-10 w-2 bg-Gray-500" />
          <a href="tel:1833-9363" className="text-Gray-700">
            1833-9363
          </a>
        </li>
        <li className="pointer-events-none whitespace-nowrap break-keep flex-center typo-caption1">
          제호: 웰로
        </li>
        <li className="pointer-events-none break-keep typo-caption1">
          인터넷신문 등록번호: 세종 아00182 (등록일 2026.04.23)
        </li>
        <li className="pointer-events-none break-keep typo-caption1">
          발행인: 김유리안나 | 편집인: 신아론 | 청소년보호책임자: 신아론
        </li>
      </ul>
      <ul className="m-0 flex flex-wrap justify-center gap-10 p-0">
        <li>
          <a href="https://www.ftc.go.kr/bizCommPop.do?wrkr_no=7058602126" rel="noreferrer" target="_blank" className="cursor-pointer whitespace-nowrap break-keep border-none font-600 text-Gray-700 no-underline typo-caption1">
            사업자정보확인
          </a>
        </li>
        <li>
          <button type="button" onClick={() => setTermsDrawerType(TERM_CATEGORY.SERVICE_TERMS)} className="cursor-pointer whitespace-nowrap break-keep border-none font-600 text-Gray-700 typo-caption1">
            이용약관
          </button>
        </li>
        <li>
          <button type="button" onClick={() => setTermsDrawerType(TERM_CATEGORY.PRIVACY_POLICY)} className="cursor-pointer whitespace-nowrap break-keep border-none font-600 text-Gray-700 underline typo-caption1">
            개인정보처리방침
          </button>
        </li>
        <li>
          <button type="button" onClick={() => setTermsDrawerType(TERM_CATEGORY.MARKETING_TERMS)} className="cursor-pointer whitespace-nowrap break-keep border-none font-600 text-Gray-700 typo-caption1">
            마케팅이용동의
          </button>
        </li>
        <li>
          <button type="button" onClick={() => setTermsDrawerType(TERM_CATEGORY.LOCATION_POLICY_SELECT)} className="cursor-pointer whitespace-nowrap break-keep border-none font-600 text-Gray-700 typo-caption1">
            위치기반서비스 이용약관
          </button>
        </li>
      </ul>
      <article className="mt-14 typo-caption2">
        <section className="mb-8">
          (주)웰로에서 제공하는 정보는 신뢰할 만한 자료 및 정보로부터 얻어진
          것이나 그 정확성이나 완전성을 보장할 수 없으며, 시간이 경과함에 따라
          변경될 수 있습니다. 따라서 정보의 오류, 누락에 대하여 (주)웰로 또는
          (주)웰로에 자료를 제공하는 기관에서는 그 결과에 대해 법적인 책임을
          지지 않습니다. (주)웰로가 소유/운영/관리하는 웹사이트 및 앱의 이벤트
          정보 및 모든 정보 UI, 콘텐츠 등에 대한 무단 복제, 배포, 발송 또는
          전송, 스크래핑 등의 행위는 관련 법령에 의하여 엄격히 금지 됩니다.
        </section>
        <Button asChild className="w-full rounded-xxsmall font-600 typo-caption2" dimensions="H26" theme="sub-line">
          <CustomLink href={ROUTES.CONTENT_COMPLIANCE_INFORMATION.pathname}>
            콘텐츠산업 진흥법에 따른 표시
          </CustomLink>
        </Button>
        <p className="mt-14 flex items-center gap-4 font-400 text-Gray-600 typo-caption2">
          <SvgInfo className="size-12" />
          일부 콘텐츠는 AI를 활용하여 제작되었습니다.
        </p>
      </article>
      <nav aria-label="소셜 미디어" className="flex justify-center gap-26 py-30">
        <a aria-label="인스타그램에서 웰로 팔로우하기" href="https://www.instagram.com/wello.info" rel="noreferrer" target="_blank" className="flex items-center text-Gray-600 no-underline">
          <Instagram className="size-38" />
        </a>
        <a aria-label="유튜브에서 웰로 구독하기" href="https://www.youtube.com/@wello_info" rel="noreferrer" target="_blank" className="flex items-center text-Gray-600 no-underline">
          <Youtube className="size-38" />
        </a>
        <a aria-label="네이버 블로그에서 웰로 방문하기" href="https://blog.naver.com/wello_official" rel="noreferrer" target="_blank" className="flex items-center text-Gray-600 no-underline">
          <NaverBlog className="size-38" />
        </a>
      </nav>

      <strong className="flex flex-col items-center font-400 text-Gray-900 typo-caption1">
        ⓒ Wello Inc.
        <div className="text-Gray-600">{appVersion}</div>
      </strong>

      <div className="my-16 h-1 w-full bg-Gray-300" />

      <CertificationBadge className="flex-col items-start" size={40} isHideCSAP />
    </footer>;
};